var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bold text-right f-medium"},[_vm._v("\n  合計"),_c('line-count',{staticClass:"line-height mx-5px my-0",attrs:{"id":_vm.id,"count":_vm.count}}),_vm._v("回線\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }